<template>
  <div class="c-container c-container--white">
    <section class="section-zero">
      <h1>Una panoramica del mercato</h1>
      <div v-if="hasCustomContent" class="content-tips" v-html="customOverview"></div>
        <div v-else>
      <p class="text-two">
        I valori riportati di seguito sono frutto di un'elaborazione delle informazioni acquisite
        <b>sui principali portali di annunci compra/vendita di moto usate*</b> presenti sul
        territorio nazionale, e rappresentano una panoramica del posizionamento del veicolo,
        <b>aggiornata in tempo reale</b>. La Quotazione DueRuote e il
        <b>prezzo di mercato</b> possono avere valori differenti in quanto la prima rappresenta il
        valore "nominale" di un veicolo, mentre il prezzo di mercato e gli altri indicatori sono
        influenzati da fattori esogeni che possono far variare il valore nel tempo. Il Report Live
        Market rappresenta una vista <b>unica e integrata</b> per dare informazioni immediate,
        complete e di qualità.
      </p>
      <p style="font-size:14px;" class="text-two">
        *Per una migliore qualità dell'informazione, l'algoritmo esclude dall'analisi gli annunci di
        veicoli incidentati o considerati "fake" con informazioni sul prezzo e/o chilometraggio
        evidentemente non realistiche.
      </p>
    </div>
    </section>

    <livemarket-data-your-car :auto="livemarket.auto"></livemarket-data-your-car>

    <livemarket-data-overview v-if="hasValidCap" :geo="livemarket.geo" :infocar="infocar"></livemarket-data-overview>

    <livemarket-data-focus :focus="livemarket.focus"></livemarket-data-focus>

    <livemarket-data-distribution :infocar="infocar" :focus="livemarket.focus"></livemarket-data-distribution>

    <livemarket-data-competitors :infocar="infocar" :competitors="livemarket.concorrenti"></livemarket-data-competitors>

    <livemarket-data-average :average="livemarket.percorrenza"></livemarket-data-average>

    <livemarket-data-alternatives v-if="hasUsedData" :usato="livemarket.usato"></livemarket-data-alternatives>
  </div>
</template>

<script>
import LivemarketDataYourCar from './LivemarketDataYourCar.vue';
import LivemarketDataOverview from './LivemarketDataOverview.vue';
import LivemarketDataFocus from './LivemarketDataFocus.vue';
import LivemarketDataDistribution from './LivemarketDataDistribution.vue';
import LivemarketDataCompetitors from './LivemarketDataCompetitors.vue';
import LivemarketDataAverage from './LivemarketDataAverage.vue';
import LivemarketDataAlternatives from './LivemarketDataAlternatives.vue';

export default {
    name: 'LivemarketDataContainer',
    props: {
    livemarket: {
      type: Object,
      required: true,
    },
    infocar: {
      type: Object,
      required: true,
    },
    customOverview: {
      type: String,
      default: '',
    },
  },
  components: {
    LivemarketDataYourCar,
    LivemarketDataOverview,
    LivemarketDataFocus,
    LivemarketDataDistribution,
    LivemarketDataCompetitors,
    LivemarketDataAverage,
    LivemarketDataAlternatives,
  },
  computed: {
    hasCustomContent() {
      const plain = this.customOverview.replace(/<[^>]+>/g, '').trim();
      // Se il contenuto è vuoto oppure equivale a "<p><br></p>" (eventualmente con spazi) lo consideriamo vuoto
      return (
        plain !== '' && this.customOverview.replace(/\s/g, '').toLowerCase() !== '<p><br></p>'
      );
    },
    hasUsedData() {
        return Array.isArray(this.livemarket.usato) && this.livemarket.usato.length > 0;
    },
    hasValidCap() {
        return this.livemarket.geo && Object.keys(this.livemarket.geo).length > 0;
    },
  },
}
</script>

<style scoped>
.c-container--white {
  background-color: white;
}
.section-zero {
  display: flex;
  flex-direction: column;
  align-items: center;
  max-width: 830px;
  margin: auto;
  padding: 40px 0px 35px;
}
.section-zero h1 {
  font-size: 42px;
  line-height: 56px;
  letter-spacing: 0px;
  color: #d20a11;
  font-weight: 300;
}
.section-zero p {
  font-size: 16px;
  line-height: 24px;
  letter-spacing: 0px;
  margin-top: 15px;
  font-weight: 300;
  color: #333333;
  text-align: center;
}
.section-zero p b {
  font-weight: bold;
}
.text-two {
  font-size: 0.875rem;
  line-height: 18px;
  margin-top: 5px;
}
.text-two b {
  font-weight: bold;
}
@media (max-width: 992px) {
    .section-zero {
        flex-direction: column;
        padding: 55px 0px 40px;
        margin: 0px 40px;
    }
}
@media (max-width: 600px) {
    .section-zero {
        margin: 0px 17px;
    }
    .section-zero p {
        margin-top: 22px;
        margin-bottom: 3px;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/app/components/LivemarketDataContainer.vue